import { Storage } from "aws-amplify";

const bucketName = process.env.REACT_APP_BUCKET;
const baseUrl = `https://s3-ap-southeast-1.amazonaws.com/${bucketName}/public/`;
let imageUrl = "";

export const uploadImgToS3 = async (image, compress = true) => {

    let imgFile = image;

    //Compress
    if (compress) {
        let compressedFile = await compressImages(image);
        imgFile = compressedFile;
    }

    //Rename
    let imgName = Date.now() + "-" + image["name"].replace(/[ `~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
    try {
        let result = await Storage.put(imgName, imgFile, { contentType: "image/jpeg" })
        imageUrl = baseUrl + result.key;
        console.log("Image Url: " + imageUrl);
        return { url: imageUrl }
    } catch (err) {
        console.log(err);
        return err
    }
};

export const removeImgFromS3 = (key) => {

    console.log("Removing Image...", key);

    return new Promise((resolve, reject) => {
        Storage.remove(key)
            .then(result => {
                resolve(true)
            })
            .catch(err => {
                console.log(err);
                reject(false);
            });
    });

}


function compressImages(imgFile) {
    const MAX_WIDTH = 900;
    const MAX_QUALITY = 0.7 // 0 to 1

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(imgFile);
        reader.onload = event => {
            try {

                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    try {

                        let newWidth = img.width > MAX_WIDTH ? MAX_WIDTH : img.width;
                        let newHeight = Math.floor(img.height / img.width * newWidth);

                        const elem = document.createElement('canvas');
                        elem.width = newWidth;
                        elem.height = newHeight;

                        const ctx = elem.getContext('2d');
                        ctx.drawImage(img, 0, 0, newWidth, newHeight);

                        let newDataUrl = ctx.canvas.toDataURL("image/jpeg", MAX_QUALITY);

                        urltoFile(newDataUrl, "compressed-file", "image/jpeg").then((result) => {
                            resolve(result)
                        }).catch(err => {
                            console.log(err);
                            reject(err);
                        })
                    } catch (error) {
                        console.log(error);
                        reject(error);
                    }
                }
            } catch (error) {
                console.log(error);
                reject(error);
            }
        }
        reader.onerror = error => {
            console.log(error);
            reject(error);
        };

    })
}


function urltoFile(url, filename, mimeType) {
    mimeType = mimeType || (url.match(/^data:([^;]+);/) || '')[1];
    return (fetch(url)
        .then(function (res) { return res.arrayBuffer(); })
        .then(function (buf) { return new Blob([buf], { type: mimeType }); })
    );
}

